import React, { lazy, Suspense } from "react";
import ReactDOM from "react-dom";
import "./styles/index.css";

const App = lazy(() => import("./App"));
const ConnectionStatusModal = lazy(() => import("components/ConnectionStatusModal"));

import reportWebVitals from "./reportWebVitals";
import AppLoader from "components/Base/Loader";
import { AppTenantConfig, getConfig, ThemeInjector } from "tenants/ThemeInjector";
import { BrandingHeader } from "components/Header";

ReactDOM.render(
  <React.StrictMode>
    <Suspense fallback={<Loading />}>
      <App />
      <ConnectionStatusModal />
    </Suspense>
  </React.StrictMode>,
  document.getElementById("root")
);

reportWebVitals();

function Loading() {
  const config = getConfig();

  return (
    <>
      <BrandingHeader />
      <ThemeInjector theme={config} />
      <div className="flex flex-col items-center justify-center w-screen h-screen bg-black gap-y-5 bg-opacity-5 backdrop-blur-sm">
        <AppLoader />
        <div className="text-lg font-medium text-primaryColor">{AppTenantConfig.brand.name}</div>
      </div>
    </>
  );
}